var map = {
	"./add.svg": "5110",
	"./adress-ico.svg": "bc23",
	"./arrow-down.svg": "f66a",
	"./arrow-up.svg": "ed2c",
	"./audio.svg": "2d66",
	"./close.svg": "864a",
	"./customer-dislike.svg": "e044",
	"./customer-like.svg": "b2d4",
	"./customer-total-ico.svg": "28e6",
	"./doc.svg": "d019",
	"./image.svg": "8ad7",
	"./link-break.svg": "29b3",
	"./link-online.svg": "b333",
	"./load-add.svg": "d48d",
	"./media.svg": "9bc4",
	"./more.svg": "d5d3",
	"./morenfujian.svg": "49bf",
	"./nav.svg": "6720",
	"./pdf.svg": "8989",
	"./ppt.svg": "a776",
	"./qyweixin.svg": "21aa",
	"./search-editor.svg": "ac5b",
	"./search-tips.svg": "239e",
	"./search.svg": "679a",
	"./star.svg": "4e5a",
	"./tabar-add.svg": "b1cd",
	"./tabar-copy.svg": "0c8a",
	"./tabar-mine.svg": "da5d",
	"./tabar-my.svg": "95ab",
	"./tabar-other.svg": "b164",
	"./tabar-setting.svg": "92c3",
	"./txt.svg": "8f7b",
	"./weixin.svg": "e067",
	"./xls.svg": "2f4c",
	"./zip.svg": "a75d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";